import React, { useState, useRef } from "react";
import { Link, useHistory } from "react-router-dom";

import inboxService from "venuescanner-js/react/components/Inbox/services/inboxService";

const MatchIgnore = ({ match, setAction }) => {
  const messageInputTextRef = useRef();
  const [selectedReason, setSelectedReason] = useState(null);
  const [loading, setLoading] = useState(false);
  let history = useHistory();

  const ignoreReasons = [
    `This venue is too expensive`,
    `I'm looking for a different style of venue`,
    `This venue is in the wrong location`,
    `I've already found a venue for my event`,
    "Other reason",
  ];
  const reasonButtons = ignoreReasons.map((reason) => (
    <span
      key={reason}
      className={`match-ignore__reason ${
        selectedReason === reason ? "isSelected" : ""
      }`}
      onClick={() => setSelectedReason(reason)}
    >
      {reason}
    </span>
  ));

  const handleSubmit = () => {
    setLoading(true);
    return inboxService
      .leadIgnore({
        _id: match._id,
        message: messageInputTextRef.current.value,
        reason: selectedReason,
      })
      .then(() => {
        setLoading(false);
        history.push("/inbox/matches");
      })
      .catch((err) => {
        console.log("LeadIgnore: submit error - ", err);
      });
  };

  return (
    <div className="match-ignore">
      <div className="match-ignore__wrapper">
        {loading ? (
          <span className="loading" />
        ) : (
          <>
            <span className="h2">&#128075;</span>
            <h3 className="match-ignore__title">Decline Match</h3>
            <p>
              Let us know why this venue wasn't right,
              <br />
              We'll use this to recommend better venues
            </p>
            <div className="match-ignore__reasons">{reasonButtons}</div>
            {selectedReason && (
              <div className="match-ignore__message">
                <span className="match-ignore__message__caption p small">
                  Add a message:
                </span>
                <textarea
                  className="p small"
                  name="message"
                  ref={messageInputTextRef}
                />
              </div>
            )}
            <p className="small">
              Don’t worry, this feedback will not be sent to the host
            </p>
            <div className="match-ignore__ctas">
              <Link to="/inbox/matches">
                <button className="button button--light">Go back</button>
              </Link>
              <button
                className={`button button--light ${
                  selectedReason ? "isValid" : "isInvalid"
                }`}
                onClick={() => handleSubmit()}
              >
                Continue
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MatchIgnore;
